// extracted by mini-css-extract-plugin
export default {"multi-select":"subfracc_multi-select__2XaTp","multi-label":"subfracc_multi-label__sD0qU","multi-box":"subfracc_multi-box__4fMuk","multi-option":"subfracc_multi-option__gozn+"};